import React from 'react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { legalDocs } from '../data/legal';
import { IMAGES } from '../data/images';
import { NotFound } from './NotFound';
export function Legal({
  slug
}: {
  slug: string;
}) {
  const doc = legalDocs.find(d => d.slug === slug);
  if (!doc) return <NotFound data-id="element-837" data-mp="nra4dhy831b0" />;
  return <>
      <Seo title={doc.title} description={`${doc.title} for Homeland Personal Protection LLC.`} data-id="element-838" data-mp="a1ykckng43kt" />
      <PageHero title={doc.title} sub={`Last updated ${doc.updated}`} image={IMAGES.rangeWide} crumbs={[{
      label: doc.title
    }]} data-id="element-839" data-mp="es55gair15yb" />
      <section className="gutter section bg-white" data-id="element-840" data-mp="4k3ijxm1crz">
        <div className="grid gap-x-16 gap-y-10 lg:grid-cols-2 3xl:grid-cols-3" data-id="element-841" data-mp="1o5ywpocq42">
          {doc.sections.map(s => <div key={s.heading} className="border-t border-navy/15 pt-6" data-id="element-842" data-mp="3n8gtii570i2l">
              <h2 className="t-h3 text-navy" data-id="element-843" data-mp="3nakt4nw26ux2">{s.heading}</h2>
              <p className="mt-3 max-w-[48rem] leading-relaxed text-steel" data-id="element-844" data-mp="3s6067dm8smsf">{s.body}</p>
            </div>)}
        </div>
        <p className="mt-14 text-sm text-steel" data-id="element-845" data-mp="27n7p6fszbrx4">Questions? Call (702) 375-5900. © Homeland Personal Protection LLC.</p>
      </section>
    </>;
}